import { createApi } from '@reduxjs/toolkit/query/react'

import { IDataProviderFilter, Logic, Operator } from 'core-components/types'
import StorageKeys from 'src/core/classes/cache/StorageKeys'
import { CORE_FORM } from 'src/core/constants/crudFormsData'
import { getBaseUrl } from 'src/core/store/service/helpers/getBaseUrl'
import { getCustomQuery } from 'src/core/store/service/helpers/getCustomQuery'
import { getResponseHandler } from 'src/core/store/service/helpers/getResponseHandler'

import type { ILogo } from './types/logo'

export const logoApi = createApi({
  reducerPath: '@app/api/logo',
  baseQuery: getCustomQuery({
    storageKey: StorageKeys.logoData,
    baseUrl: getBaseUrl(CORE_FORM.cleverAppHeader.id, CORE_FORM.cleverAppHeader.code),
  }),
  endpoints: (builder) => ({
    getLogoData: builder.query<ILogo, string>({
      query: (appId: string) => {
        const filter: IDataProviderFilter = {
          logic: Logic.AND,
          filters: [
            {
              field: 'CleverAppId',
              operator: Operator.EQUAL,
              value: appId,
            },
          ],
        }
        return {
          url: ``,
          method: 'POST',
          body: { filter },
          responseHandler: getResponseHandler({
            storageKey: StorageKeys.logoData,
            prepareValue: (data) => {
              return data[0] || {}
            },
          }),
        }
      },
    }),
  }),
})

export const { useGetLogoDataQuery } = logoApi
